'use strict';

const $ = require('jquery');

class Popup {

    constructor() {

        require('./../../../../build/node_modules/@components/magnific-popup/dist/jquery.magnific-popup.js');

        App.Globals.$window.on('load reInitMagnificPopup', function () {

            $('[data-popup="video"]').magnificPopup({
                disableOn: 600,
                type: 'iframe',
                closeMarkup: '<span title="%title%" class="mfp-close">&#215;</span>'
            });

            $('[data-popup="form"]').on('click', function (event) {
                event.preventDefault();

                let $this = $(this);

                let title = $this.data('popup-title');
                let downloadId = $this.data('popup-download-id');
                let redirect = $this.data('popup-redirect');

                let $target = $this.attr('href');
                let $content = $($target).clone();

                if (title) {
                    $content
                        .find('[data-popup-title-holder]')
                        .html(title);
                }

                if (downloadId) {
                    $content
                        .attr('data-popup-download-id', downloadId)
                        .find('.gfield.download input')
                        .attr('value', downloadId);
                }

                if (redirect) {
                    $content.attr('data-popup-redirect', redirect);
                }

                $.magnificPopup.open({
                    items: {
                        src: $content,
                        type: 'inline'
                    }
                });

            });

        });

    }

}

module.exports = Popup;
